<template>
  <div class="listStyle" v-if="lists && lists.length">
    <div class="title">
      <img src="@/assets/imgs/index/floor_icon.png" alt="" v-if="info.title" />
      <span>{{ info.title }}</span>
      <span class="page"
        ><span class="currentPage">{{ currentPage }}</span
        >/{{ lists.length }}</span
      >
    </div>
    <div class="showList">
      <el-carousel
        :interval="200000"
        height="335px"
        trigger="click"
        indicator-position="none"
        :autoplay="false"
        @change="change"
      >
        <el-carousel-item v-for="(item, index) in lists" :key="index">
          <ul class="firstList">
            <li
              v-for="(value, key) in item"
              :key="key"
              @click="toDetail(value.id)"
              style="cursor:pointer"
            >
              <div class="goodsImg-wrap">
                <img :src="value.imgUrl" alt="" class="goodsImg" />

                <div class="show-detail-info">
                  <div class="show-detail-info-wrap">
                    <div class="show-detail-info-item">
                      <h4>{{TLang('时间','my')}}</h4>
                      <p>{{ value.timeInfo }}</p>
                    </div>

                    <div class="show-detail-info-item">
                      <h4>{{TLang('场馆','my')}}</h4>
                      <p>
                        {{ value.venueName }}
                        <span></span>
                        {{ value.cityName }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="CheckCN()" class="secondKinds">
                {{ value.categoryName }}
              </div>
              <div v-else class="secondKindsEn">
                {{ value.categoryName }}
              </div>
              <div class="priview" v-if="value.projectType == 1">
                <img
                 :src="!CheckCN()?enPreview:zhPreview"
                  alt=""
                  style="width:100%;height:100%;"
                />
              </div>
              <div class="perform-title" :title="value.name">
                {{ value.name }}
              </div>
              <Price
                style="margin-top:5px;"
                :price="value.sellingPrice"
                :onlyOnePrice="value.onlyOnePrice"
              ></Price>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import Price from "./price";
import { unionFlag } from "@/utils";
import ZhPreview from '@/assets/imgs/index/preview_detail.png';
import EnPreview from '@/assets/imgs/index/preview_detail_en.png'
export default {
  name: "listStyle1",
  props: {
    info: Object
  },
  data() {
    return {
      currentPage: 1,
      enPreview: EnPreview,
      zhPreview: ZhPreview,
    };
  },
  components: {
    Price
  },
  methods: {
    toDetail(id) {
      let union = unionFlag();
      console.log(union);
      let { city } = this.$route.query;
      window.open(
        `/drama_pc/detail?id=${id}&city=${city}` +
          (union ? `&union=${union}` : ""),
        this.isFeishuOrDingding ? "_self" : "_blank"
      );
    },
    change(index) {
      this.currentPage = index + 1;
    },
    chartArr(arr) {
      let listArr = [];
      for (let i = 0; i < Math.ceil(arr.length / 5); i++) {
        listArr.push([]);
      }
      arr.forEach((value, index) => {
        listArr[Math.floor(index / 5)].push(value);
      });
      return listArr;
    }
  },
  computed: {
    lists: function() {
      if (this.info && this.info.searches) {
        return this.chartArr(this.info.searches);
      }
      return [];
    }
  }
};
</script>

<style lang="less" scoped>
.listStyle {
  .title {
    img {
      width: 36px;
      height: 36px;
      margin-top: 4.5px;
      margin-right: 12px;
    }
    font-size: 32px;
    height: 45px;
    line-height: 45px;
    font-weight: 540;
    margin-bottom: 28px;
    position: relative;
  }
  .showList {
    .firstList {
      .clearfix;
      li {
        overflow: hidden;
        width: 200px;
        float: left;
        margin-left: 50px;
        position: relative;
        .secondKinds {
          height: 22px;
          width: 80px;
          z-index: 99;
          line-height: 22px;
          color: white;
          background-color: rgba(0, 0, 0, 0.76);
          position: absolute;
          top: 10px;
          font-size: 10px;
          left: -19px;
          text-align: center;
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg); /* IE 9 */
          -moz-transform: rotate(-45deg); /* Firefox */
          -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
          -o-transform: rotate(-45deg); /* Opera */
        }
        .secondKindsEn{
          height: 25px;
          padding: 0 4px;
          // mawidth: 80px;
          max-width: 140px;
          line-height: 25px;
          color: white;
          background-color: rgba(0, 0, 0, 0.76);
          position: absolute;
          text-align: center;
          top: 0;
          left: 0;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

        }
        .priview {
          width: 48px;
          height: 25px;
          position: absolute;
          top: 0;
          right: 0;
          display: inline-block;
        }
      }
      li:nth-child(5n + 1) {
        margin-left: 0;
      }
      .goodsImg-wrap {
        position: relative;
        &:hover {
          .show-detail-info {
            display: block;
          }
        }
        .show-detail-info {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          z-index: 9;
          display: none;
        }
        .show-detail-info-wrap {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          margin-top: -52px;
        }
        .show-detail-info-item {
          margin-bottom: 24px;
          padding: 0 12px;
          line-height: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          h4 {
            color: #cbcdce;
            font-size: 12px;
          }
          p {
            font-size: 14px;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              width: 1px;
              height: 10px;
              background: #fff;
              display: inline-block;
              margin: 0 2px;
            }
          }
        }
      }
      .goodsImg {
        height: 266px;
        width: 100%;
      }
      .perform-title {
        margin-top: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
        color: #000;
      }
    }
  }
  .page {
    font-size: 12px;
    font-weight: 500;
    color: #aab1b8;
    position: absolute;
    right: 0;
    bottom: 0;
    height: 14px;
    line-height: normal;
    .currentPage {
      color: #555;
    }
  }
  /deep/.el-carousel__arrow {
    width: 29px;
    height: 40px;
    background: rgba(0, 0, 0, 0.4);
    top: 130px;
    transition: none;
    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }
  /deep/.el-carousel__arrow--left {
    left: 0;
    border-radius: 0px 100px 100px 0px;
    i {
      margin-right: 5px;
    }
  }
  /deep/.el-carousel__arrow--right {
    right: 0;
    border-radius: 100px 0px 0px 100px;
    i {
      margin-left: 9px;
    }
  }
  /deep/.el-carousel__arrow i {
    font-size: 20px;
  }
}
</style>
